export const commandType = "END_FLIGHT";
export const label = "End flight";
export const isAdminOnly = true;
export const isAdvanced = false;
export const organizations = [];
